import React, { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import BicAutosuggest from '../Dadata/BicAutosuggest/BicAutosuggest';
import { DadataBankResponse } from '../../structures/response/dadata/DadataBankResponse';

interface Props extends FieldRenderProps<string | number> {
  onItemSelected: (data: DadataBankResponse) => void;
  onDadataFailed?: () => void;
}

const BicSuggestAdapter: FC<Props> = ({
  input: { onChange, value, onBlur },
  meta,
  onItemSelected,
  ...rest
}: Props) => (
  <BicAutosuggest
    {...rest}
    onChange={(v) => {
      onChange(v);
    }}
    onBlur={onBlur}
    value={value.toString()}
    meta={{ ...meta, initial: meta.initial?.toString() }}
    onItemSelected={(data) => {
      if (meta.valid === true) {
        onItemSelected(data);
      }
    }}
  />
);

export default BicSuggestAdapter;
